import { render } from "./PageContent.vue?vue&type=template&id=646d5d4e&scoped=true"
const script = {}

import "./PageContent.vue?vue&type=style&index=0&id=646d5d4e&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646d5d4e"]])

export default __exports__